<template>
  <div id="app">
    <link rel="stylesheet" :href="require('./assets/css/v-tooltip.css')">
    <router-view></router-view>
  </div>
</template>

<script>

export default {
  name: 'app',
  mounted () {
    // Set document title based on whitelabel mode
    document.title = this.$whitelabel.getAppName()
  }
}
</script>

<style>

import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
</style>
